window.maxLengthCheck = (object) => {
  if (object.value > 10) object.value = 10;
  if (object.value < 1) object.value = 1;
};

$(() => {
  $('#datepicker-event').datepicker({
    format: 'mm-dd-yyyy',
    language
  });

  $('form[name="category"]').submit(function () {
    if ($(this).find('input[name="event-title"]').length > 0) {
      $(this).find('input[name="event-title"]').val($('#name').val());
      $(this).find('input[name="event-date"]').val($('#date').val());
      $(this).find('input[name="event-services"]').val($('#services').val());
    }
    if ($(this).find('input[name="event-services"]').length > 0) {
      $(this).find('input[name="event-services"]').val($('#services').val());
    }
  });
});

let addonCost = 0.00;

function onAddonCheckboxChanged() {
  const parentRow = $(this).closest('tr');
  const isChecked = $(this).prop('checked');
  const addonPrice = parseFloat($(this).data('price'));
  const basePrice = parseFloat(parentRow.data('base-price'));
  const type = $(this).data('type');
  const addonInput = parentRow.find(`input[type="hidden"][name="${type}"]`);

  if (isChecked) {
    addonCost += addonPrice;
    addonInput.val('1');
  } else {
    addonCost -= addonPrice;
    addonInput.val(null);
  }

  const priceEl = parentRow.find('.price');
  priceEl.find('.value').html((basePrice + addonCost).toFixed(2));

  priceEl.removeClass('blink-text');
  setTimeout(() => {
    priceEl.addClass('blink-text');
  }, 0);
}

$('.addon-checkbox').change(onAddonCheckboxChanged);
